export default __webpack_public_path__ + "5dd4494faf08b191500beb5d2d821ce7.png";